export const DOT_WRAPPER_CATEGORY_KEY = 'base' as const;
export const DOT_WRAPPER_PARENT_COMPONENT_KEY = 'carousel' as const;
export const DOT_WRAPPER_COMPONENT_KEY = 'dotWrapper' as const;
